<bs-digital-result-links
    [succeededSlips]="succeededSlips"
    [failedSlips]="failedSlips"
    [shouldShowQuickLinks]="showQuickLinks"
    [trackingInformation]="trackingInformation"
    [shouldShowShareMyBet]="true">
</bs-digital-result-links>
